module.exports = __webpack_public_path__ + "static/media/quote.db44c137.svg";